import React from 'react';
import Cropper from 'react-cropper';

export default function ReactCropper({image, onCrop,cropperRef}) {
  return (
    <Cropper
      src={image && image.src}
      style={{
        width: '100%',
        height: '250px',
        borderRadius: 5,
      }}
      viewMode={1}
      responsive={true}
      dragMode="move"
      initialAspectRatio={1}
      aspectRatio={1}
      guides={false}
      crop={onCrop}
      ref={cropperRef}
    />
  );
}
